import config from './environment';

export const apiConfig = {
  baseURL: config.apiUrl,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  }
};

// Environment-specific logging
if (config.debug) {
  console.log('🔧 API Configuration:', {
    environment: config.env,
    baseURL: config.apiUrl,
    debug: config.debug
  });
}

export default apiConfig;
